module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "page",
      _vm.appPage.classes,
      {
        'page--is-loaded': _vm.appState.loaded,
      } ],
    attrs: {
      "id": "app",
      "data-env": _vm.appEnv
    }
  }, [_c('ui-header'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "loader",
      "mode": "out-in"
    },
    on: {
      "appear": function($event) {
        _vm.onLoad()
      },
      "enter": function($event) {
        _vm.onLoad()
      },
      "leave": function($event) {
        _vm.onLeave()
      }
    }
  }, [_c('router-view', {
    key: _vm.$route.meta.key || _vm.$route.fullPath
  })], 1), _vm._v(" "), _c('module-modal', {
    attrs: {
      "id": "login",
      "auto": true,
      "no-close": true,
      "auth": "login"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63713ffd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 129
// module chunks = 3